import cx from 'classnames';
import React from 'react';
import styles from './PropertyValue.mscss';

interface OwnProps {
    className?: string;
    property: string;
    label: React.ReactNode;
    value: string | number;
}

type Props = OwnProps;

const PropertyValue: React.FunctionComponent<Props> = ({ className, property, value, label }) => (
    <span className={cx(styles.PropertyValue, styles[`PropertyValue--${property}`], className)}>
        <span
            className={cx(
                styles.PropertyValue__icon,
                styles[`PropertyValue__icon--${property}`],
                styles[`PropertyValue__icon--${property}-${value}`],
            )}
        />
        <span
            className={cx(
                styles.PropertyValue__label,
                styles[`PropertyValue__label--${property}`],
                styles[`PropertyValue__label--${property}-${value}`],
            )}
        >
            {label}
        </span>
    </span>
);

PropertyValue.displayName = 'PropertyValue';

export default React.memo<Props>(PropertyValue);
